import React from 'react'
import Link from 'next/link'
import { Button, Typography } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import styles from './ApiKeyModal.module.scss'
import { integrationStaticsSelector } from 'src/features'
import CustomModal from 'src/components/base/CustomModal/CustomModal'
const { Text, Paragraph } = Typography

interface ApiKeyModalProps {
  isModalVisible: boolean
  // eslint-disable-next-line no-unused-vars
  setIsModalVisible: (value: boolean) => void
}


const ApiKeyModal: React.FC<ApiKeyModalProps> = ({ isModalVisible, setIsModalVisible }) => {
  const { t } = useTranslation()
  const { data } = useAppSelector(integrationStaticsSelector)

  return (
    <>
      <CustomModal
        title={t('Api Key')}
        footer={null}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
      >
        <div className='centered-div'>
          <Text
            className={styles['apikey-font']}
            type='secondary'
          >
            {t('developers.ApiKeyText')}
          </Text>
        </div>
        <div className={`centered-div mt-3 mb-5`}>
          <fieldset className={`${styles['border-stroke']}`}>
            <legend className={`${styles['legend-title']}`}>
              {t('developers.APIKeyProduction')}
            </legend>
            <Paragraph copyable>
              {data?.integration_token}
            </Paragraph>
          </fieldset>
        </div>

        <div  className='centered-div mt-1'>
          <Link href={process.env.DEV_PORTAL_URL} passHref legacyBehavior>
            <a target='_blank' rel='noopener noreferrer'>
              <Button
                style={{ width: '22em' }}
                type='default'
                size='large'
                className='radius-100'
                shape='round'
                block
              >
                {t('developers.GoToApiDocs')}
              </Button>
            </a>
          </Link>
        </div>
      </CustomModal>
    </>
  )
}
export default ApiKeyModal
